export default {
  "tagsAdmin.thead.index": "#NO",
  "tagsAdmin.thead.tagId": "TagId",
  "tagsAdmin.thead.groupId": "GroupId",
  "tagsAdmin.thead.tagName": "TagName",
  "tagsAdmin.thead.groupName": "Group Name",
  "tagsAdmin.thead.tagSeqName": "tagSeqName",
  "tagsAdmin.thead.groupSeqName": "GroupSeqName",
  "tagsAdmin.thead.tagIcon": "tagIcon",
  "tagsAdmin.thead.tagType": "TagType",
  "tagsAdmin.thead.color": "Color",
  "tagsAdmin.thead.groupColor": "Group Color",
  "tagsAdmin.thead.sortWeight": "SortWeight",
  "tagsAdmin.thead.status": "Status",
  "tagsAdmin.thead.createTime": "CreateTime",
  "tagsAdmin.thead.modifyTime": "ModifyTime",
  "tagsAdmin.thead.action": "Action",
  "tagsAdmin.add": "Add",
  "tagsAdmin.details": "Details",
  "tagsAdmin.edit": "Edit",
  "tagsAdmin.disable": "Disable",
  "tagsAdmin.enable": "Enable",
  "tagsAdmin.gameSort": "GameSort",
};
